import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $(this.element).select2({
      width: "100%",
      matcher: function (params, data) {
        let original_matcher = $.fn.select2.defaults.defaults.matcher;
        let result = original_matcher(params, data);
        if (
          result &&
          data.children &&
          result.children &&
          data.children.length != result.children.length &&
          data.text.toLowerCase().includes(params.term)
        ) {
          result.children = data.children;
        }
        return result;
      },
      placeholder: this.element.dataset.placeholder || "== Pilih ==",
      // Opt-in via `data-tags="true"`: lets the admin type a value that does
      // not exist yet instead of leaving the form to go create it first. The
      // typed text is submitted as the field value; the server treats a
      // non-UUID value as a new name (see Webinars::BaseService).
      tags: this.element.dataset.tags === "true",
    });
  }
}
